import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useGetLabelsQuery } from "@store/labelApi";
import { Autocomplete, Stack, TextField } from "@mui/material";
import { SectionTitle } from "@components/PhotoFilters/SectionTitle";
import { Controller, UseFormReturn } from "react-hook-form";
import { PhotoSearchFilters } from "@store/photoApi";

const LabelFilters: FC<{
  patientId: string;
  form: UseFormReturn<PhotoSearchFilters>;
}> = ({ patientId, form }) => {
  const { t } = useTranslation();
  const { data: labels } = useGetLabelsQuery({ patientId });

  return (
    <Stack>
      <SectionTitle>
        {t("albums.addPhotosDialog.filters.labels.title")}
      </SectionTitle>

      <Controller
        name="labelIds"
        control={form.control}
        render={({ field: { onChange } }) => (
          <Autocomplete
            multiple
            options={labels?.data || []}
            getOptionLabel={(label) => label.name}
            defaultValue={[]}
            onChange={(e, labels) => onChange(labels.map(({ id }) => id))}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="outlined"
                placeholder={t(
                  "albums.addPhotosDialog.filters.labels.input.placeholder",
                )}
              />
            )}
          />
        )}
      />
    </Stack>
  );
};

export default LabelFilters;
